import {GRID_SET, NO_GRID_CHANNELS} from "data/products/index";
import {bgMarkersFromUrl} from "libs/bgMarkers";

/**
 * Should this template draw the grid overlay?
 *
 * Two independent reasons: the product always grids (GRID_SET, except on the
 * channels in its noGridChannels), or the background image itself is a grid
 * image. The second used to be read as `src.includes("_grid")` — Kraken
 * filenames carried the marker. Re-hosted
 * catalog urls are content-hashed (`bg/<sha12>.png`), so under bgDerivation the
 * filename says nothing and the marker has to come from catalog data, the same
 * way the logo variant does (#567).
 *
 * The catch is that BgTransformer's `src` is not always the resolved background:
 * Livestream renders a per-template baked asset out of `customBgs`/LIVESTREAM_BGS
 * and Ads renders a url out of its manifest, neither of which the catalog knows
 * anything about. So markers apply only when `src` IS the url useBgUrl resolved,
 * and any other source falls back to parsing its own filename — which is
 * lossless for those, because they are not re-hosted.
 */
export function resolveShowGrid({
  productValue,
  channel,
  src,
  bgUrl,
  bgMarkers,
}: {
  productValue: string | null | undefined;
  channel: string | null | undefined;
  src: string | null | undefined;
  bgUrl: string | null | undefined;
  bgMarkers: readonly string[] | null | undefined;
}): boolean {
  if (productValue && GRID_SET.has(productValue) && !NO_GRID_CHANNELS[productValue]?.includes(channel)) {
    return true;
  }
  if (!src) return false;

  const markers = src === bgUrl ? bgMarkers : bgMarkersFromUrl(src);
  return Boolean(markers?.includes("showgrid"));
}
